import { render, staticRenderFns } from "./RecipeNutrient.vue?vue&type=template&id=95d7718a&"
import script from "./RecipeNutrient.vue?vue&type=script&lang=js&"
export * from "./RecipeNutrient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports